import { render, staticRenderFns } from "./UnnasignedWorkOrders.vue?vue&type=template&id=16ad4b84&scoped=true&"
import script from "./UnnasignedWorkOrders.vue?vue&type=script&lang=js&"
export * from "./UnnasignedWorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./UnnasignedWorkOrders.vue?vue&type=style&index=0&id=16ad4b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ad4b84",
  null
  
)

export default component.exports